/**
 * /dashboard/accounting/contacts — Contacts list (G_ACC3b).
 *
 * Customers, vendors, employees and other parties referenced by your
 * books. The ContactList itself drives the filters and pagination.
 *
 * Role-gate is the in-page UX mirror of the backend's
 * accountingRole = RequireRole(company_admin, hr_manager, accountant).
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/contacts/page.tsx.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { ContactList } from "@/components/accounting/contact-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/accounting/contacts/")({
  component: ContactsListRoute,
});

function ContactsListRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <AccountingModuleShell
      title="Contacts"
      description="Customers, vendors, employees and other parties referenced by your books."
      actions={
        <Button asChild className="gap-1.5">
          <Link to="/app/$tenantSlug/accounting/contacts/new" params={{ tenantSlug }}>
            <Plus aria-hidden className="h-4 w-4" />
            Add Contact
          </Link>
        </Button>
      }
    >
      <ContactList />
    </AccountingModuleShell>
  );
}
